export const SIGNIN_FORM = 'signIn'

export const LOGIN = 'login'
export const PASSWORD = 'password'
export const EMAIL = 'email'
export const REPEAT_PASSWORD = 'repeatpassword'
export const USERNAME = 'username'
